var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcgIconBlackAndWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.11 8.45L12 6.24L8.89 12.45C8.73 12.79 8.38 13 8 13C7.62 13 7.27 12.79 7.11 12.45L5.38 9H0V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V9H14C13.62 9 13.27 8.79 13.11 8.45Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C0.9 0 0 0.9 0 2V7H6C6.38 7 6.73 7.21 6.89 7.55L8 9.76L11.11 3.55C11.45 2.87 12.56 2.87 12.9 3.55L14.62 7H20V2C20 0.9 19.1 0 18 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcgIconBlackAndWhite);
export default __webpack_public_path__ + "static/media/ecg-icon-black-and-white.d37f5e3f3e0a7f85036ff244e95b78cf.svg";
export { ForwardRef as ReactComponent };